export enum ApiMode {
  API = 'api',
  MOCK = 'mock',
}

export enum ApiHeaders {
  LANGUAGE = 'X-KAA-LANGUAGE',
  APP_ID = 'X-KAA-APP-ID',
}
